import type { TrackEventOptions } from '@gtm-support/vue-gtm';
import { useGtm as _useGtm } from '@gtm-support/vue-gtm';

export const useGtm = () => {
  const gtm = _useGtm();

  const trackEvent = (options: TrackEventOptions) => {
    if (process.client && gtm) {
      gtm.trackEvent(options);
    }
  };

  return {
    trackEvent,
  };
};
